import { inject, nextTick, provide, ref } from "vue";
export const TRANSCRIPT_ANNOUNCER_KEY = Symbol();
export const initAnnouncerContext = () => {
    const message = ref("");
    // Clear then set on the next tick so an identical repeat still mutates the
    // live region (screen readers only announce on content change).
    const announce = (text) => {
        message.value = "";
        void nextTick(() => {
            message.value = text;
        });
    };
    const context = { message, announce };
    provide(TRANSCRIPT_ANNOUNCER_KEY, context);
    return context;
};
// Safe default so TranscriptMessage can mount without a provider (isolated tests).
export const useAnnouncer = () => inject(TRANSCRIPT_ANNOUNCER_KEY, {
    message: ref(""),
    announce: () => { }
});
